export function extractTagFromUrl(url: string): string | null {
  const parts = url.split('/');
  const lastPart = parts.pop();

  const filteredLastPart = lastPart ? lastPart.replace(/[\n\s]/g, '') : null;

  return filteredLastPart;
}